export default "__VITE_ASSET__DcEEbuPl__"